
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PulseHeader from '../components/PulseHeader';
import PulseLogo from '../components/PulseLogo';
import { toast } from 'sonner';
import { resetPassword } from '@/services/auth';
import { isNativePlatform } from '@/utils/deep-links';

const ResetPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const isNative = isNativePlatform();

  const handleResetPassword = async (e: React.FormEvent) => {
    e.preventDefault();
    
    // Basic validation
    if (!email) {
      toast.error('Por favor, insira seu email');
      return;
    }
    
    setLoading(true);
    
    try {
      // Call the resetPassword function from the auth service
      const { error } = await resetPassword(email);
      
      if (error) {
        setLoading(false);
        return; // Error toast is already shown in the resetPassword function
      }
      
      setSubmitted(true);
      toast.success('Link de recuperação enviado para seu email');
    } catch (error) {
      console.error('Error in reset password:', error);
      toast.error('Ocorreu um erro ao processar sua solicitação');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pulse-container min-h-[var(--app-height)] overflow-y-auto bg-primary-900 text-white">
      <PulseHeader title="Recuperar Senha" />
      
      <div className="flex-1 flex flex-col items-center justify-center p-6 text-center pb-16">
        <PulseLogo size="lg" />
        
        {submitted ? (
          <div className="mt-8 space-y-6">
            <p>Enviamos um link para recuperar sua senha no email: <strong>{email}</strong></p>
            <p>Verifique seu email e siga as instruções para redefinir sua senha.</p>
            {!isNative && (
              <p className="text-sm mt-4 bg-pink-800/30 p-3 rounded-lg">
                <strong>Dica:</strong> Se você tem o aplicativo Pulse instalado em seu dispositivo, 
                o link de recuperação irá abrir automaticamente o app para uma experiência melhor!
              </p>
            )}
            <Link to="/login" className="pulse-btn-primary inline-block mt-8">
              Voltar para o Login
            </Link>
          </div>
        ) : (
          <>
            <p className="mt-2 mb-8">Recupere o acesso à sua conta</p>
            
            <form onSubmit={handleResetPassword} className="w-full space-y-6">
              <div className="space-y-2 text-left">
                <label htmlFor="email" className="block">Email</label>
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Insira o email da sua conta"
                  className="auth-input"
                />
              </div>
              
              <button 
                type="submit" 
                className="pulse-btn-primary mt-8"
                disabled={loading}
              >
                {loading ? 'Enviando...' : 'Enviar link de recuperação'}
              </button>
            </form>
            
            <p className="mt-8">
              <Link to="/login" className="pulse-link">
                Voltar para o login
              </Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default ResetPassword;
